import React, { Component } from "react";
import { Modal, Button, Typography, Icon } from "@plum-xoxo/admin-dsm";
import { useState } from "react";
import { useEffect } from "react";
function ActionModal({
  footerClassName = "",
  image,
  header,
  headerColor,
  bodyColor,
  body,
  buttonText,
  modalClassName,
  actionModalSubHeader = "",
  cancelBtnText = "No, Cancel",
  imageClass = "",
  cancelColWidth = "4",
  okColWidth = "8",
  minWidth,
  loading = false,
  hideCancelBtn = false,
  plumProPopup = false,
  title,
  showModal: showModalProps,
  callbackMethod,
  actionHandler,
}) {
  const [showModal, setShowModal] = useState(true);
  //this.handleClose = this.handleClose.bind(this);

  const handleModal = (fromHeader = false) => {
    setShowModal(false);
    callbackMethod ? callbackMethod(fromHeader) : null;
  };
  return (
    <div>
      <Modal
        isOpen={showModal}
        className={
          modalClassName ? `${modalClassName} message-modal` : "message-modal"
        }
        disableCloseButton={false}
        onClose={() => {
          handleModal();
        }}
        style={{ width: minWidth ? minWidth : "476px" }}
      >
        <div className="d-flex justify-content-between align-items-center">
          {title ? (
            <Typography.H2 className="mb-12" color="dark" shade="c300">
              {title}
            </Typography.H2>
          ) : null}

          {/* <Icon
              iconName="Close"
              onClick={() => {
                this.handleModal();
              }}
              size="m"
            /> */}
        </div>
        {/* <img
            className={`${imageClass ? imageClass : ""} img-fluid`}
            src={
              image == "success"
                ? "/admin/img/icons/campaign_success_icon.svg"
                : image != ""
                ? image
                : null
            }
          /> */}
        {header ? <Typography.H2>{header}</Typography.H2> : null}
        {actionModalSubHeader ? (
          <Typography className="mt-16">{actionModalSubHeader}</Typography>
        ) : null}
        {body ? (
          <Typography className="mt-0 mb-32" color="dark" shade="c200">
            {body ? body : ""}
          </Typography>
        ) : null}

        <Typography
          component="div"
          className="d-flex justify-content-end w-100 mt-0"
        >
          {cancelBtnText ? (
            <Button
              variant="plain"
              onClick={() => {
                handleModal();
              }}
              className="mr-4"
            >
              {cancelBtnText}
            </Button>
          ) : null}

          <Button
            onClick={() => {
              actionHandler();
            }}
            loading={loading}
            disabled={loading}
          >
            {buttonText ? buttonText : "Create"}
          </Button>
        </Typography>
        {/* <Row>
            {hideCancelBtn ? null : (
              <Col xs={cancelColWidth ? cancelColWidth : "4"}>
                <Button
                  color="secondary medium"
                  onClick={() => {
                    this.handleModal();
                  }}
                >
                  {cancelBtnText}
                </Button>
              </Col>
            )}
            <Col xs={okColWidth ? okColWidth : "8"}>
              <Button
                color="primary "
                onClick={() => {
                  this.props.actionHandler();
                }}
              >
                {loading ? <ImageLoader /> : buttonText ? buttonText : "Create"}
              </Button>
            </Col>
          </Row> */}
      </Modal>
    </div>
  );
}

export default ActionModal;
